/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Utilizationrate1Inputs */

const en_entity_utilizationrate1 = /** @type {(inputs: Entity_Utilizationrate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilization Rate`)
};

const de_entity_utilizationrate1 = /** @type {(inputs: Entity_Utilizationrate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslastungsrate`)
};

/**
* | output |
* | --- |
* | "Utilization Rate" |
*
* @param {Entity_Utilizationrate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_utilizationrate1 = /** @type {((inputs?: Entity_Utilizationrate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Utilizationrate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_utilizationrate1(inputs)
	return de_entity_utilizationrate1(inputs)
});
export { entity_utilizationrate1 as "entity_utilizationRate" }